import moment from 'moment';

export default abstract class BaseEntity {
    public readonly id: number;
    public readonly active: boolean;
    public readonly className: string;
    public readonly createdAt: moment.Moment;
    public readonly modifiedAt: moment.Moment;

    protected constructor(json: any) {
        this.id = json.id;
        this.active = json.active;
        this.className = json.className;
        this.createdAt = moment(json.createdAt);
        this.modifiedAt = moment(json.modifiedAt);
    }

    public abstract toString(): string;
}
